
declare var dataLayer: any;
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import ClickOutside from "vue-click-outside";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";

@Component({
  directives: {
    ClickOutside
  },
  components: {
    Navbar: () => import("@/components/onboarding/createaccount/Navbar.vue"),
    ConnectWithSocialNetwork: () =>
      import("@/components/onboarding/ConnectWithSocialNetwork.vue"),
    Tips: () => import("@/components/onboarding/createaccount/Tips.vue"),
    AttachingFile: () =>
      import("@/components/onboarding/createaccount/AttachingFile.vue"),
    AttachFile: () => import("@/components/Jobs/Common/AttachFile.vue"),
    WorkExperience: () => import("@/components/Jobs/Common/WorkExperience.vue"),
    ExperienceUser: () => import("@/components/Jobs/Common/ExperienceUser.vue"),
    ProfessionalInformation: () =>
      import("@/components/Jobs/Common/ProfessionalInformation.vue"),
    AcademicInformation: () =>
      import("@/components/Jobs/Common/AcademicInformation.vue"),
    PasswordInput: () => import("@/components/Jobs/Common/PasswordInput.vue"),
    PhoneInput: () => import("@/components/Jobs/Profile/PhoneInput.vue"),
  },
  computed: {
    socialName() {
      return ["Facebook", "Google", "Linkedin", "Twitter"].find(
        (network) => this.$store.state.user[`${network.toLowerCase()}_id`]
      );
    },
  },
})
export default class CreateSteps extends Vue {
  @Prop(Number) activeStep!: number;
  busy_api = false;
  is_counting = false;
  current_step = 1;
  status_attach = "initial";
  email = "";
  selected_cv = 5;
  es = es;
  visibile = false;

  user_exp = {
    title: "",
    description: "",
    from: "",
    to: "",
  };

  curriculum = false;
  curriculum_add = false;
  form = {
    name: "",
    ape: "",
    email: "",
	  email2: "",
    cel: "",
    est: "",
    emp: "",
    pass: "",
    rpass: "",
    type_document: "",
    number_document: "",
    age: "",
    nationality: "",
    address: "",
    location: "",
    number_address: "",
    floor_address: "",
    dept_address: "",
    checked1: null,
    checked: 0,
    title: "",
    nucleusTypeId: "",
    company: "",
    current_job: false,
    from: "",
    to: "",
    description: "",
    study_level: "",
    study: "",
    study_status: "",
    university: "",
    phonepais: "",
    phonearea: null,
    phone: null,
  };
  profession_user = {
    profession: "",
    area: "",
    desired_place_lat: "",
    lowest_expected_salary: 100000,
    highest_expected_salary: 3000000,
    is_part_time: false,
    is_full_time: false,
    is_remote: false,
    is_temporal: false,
    wants_job_offers: false,
  };
  optionsEst = [];
  optionsEmp = [];
  typeDoc = [];
  nacionalidad = [];
  educationCareer = [];
  educationStatus = [];
  countries = [];
  slider_rank = [100000, 3000000];
  optionsSlider = {
    interval: 5000,
    dotSize: 20,
    max: 3000000,
  };
  modality = false;
  radioBt = "full-time";
  select_net = false;
  select_net_step = false;
  input_pass_current = "password";
  userId = 0;
  exp_user = [];
  work_type = true;
  windowWidth = 0;
  sizeCv = 0;
  typeCv = "pdf";
  searchProffesional = 0;
  optionsPlaces = [];
  msjSlot = "Escribe una ubicacion";
  numberInvalid = false;
  dniDuplicate = false;
  emailDuplicate = false;
  errorPhone = {
    flag: true,
    type: 0,
  };
  EmailEquals = true;
  reinitExp = true;
  count_timer = null;

  @Watch("status_attach")
  successAttachFile() {
    if ((this as any).status_attach === "success") {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/crear-cuenta/adjuntar-cv-exitoso",
        virtualPageTitle: "Crear Cuenta - Adjuntar CV - Exitoso",
      });
    }
  }

  @Watch("current_step")
  analytics() {
    const _this: any = this;
    if (_this.current_step === 3) {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/crear-cuenta/estado-exitosa",
        virtualPageTitle: "Crear Cuenta - Exitosa",
      });
    }
    if (_this.current_step === 4) {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/crear-cuenta/adjuntar-cv",
        virtualPageTitle: "Crear Cuenta - Adjuntar CV",
      });
    }
    if (_this.current_step === 5) {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/crear-cuenta/quien-sos",
        virtualPageTitle: "Crear Cuenta - Quién Sos",
      });
    }
    if (_this.current_step === 6) {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/crear-cuenta/que-haces",
        virtualPageTitle: "Crear Cuenta - Qué Hacés",
      });
    }
    if (_this.current_step === 7) {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/crear-cuenta/que-buscas",
        virtualPageTitle: "Crear Cuenta - Qué Buscás",
      });
    }
    if (_this.current_step === 8) {
      dataLayer.push({
        event: "VirtualPageview",
        virtualPageURL: "/crear-cuenta/perfil-completado",
        virtualPageTitle: "Perfil Completado",
      });
    }
  }

  @Watch("profession_user", { deep: true })
  async onSetOffer() {
    const _this: any = this;
    if (_this.count_timer) window.clearInterval(_this.count_timer);
    _this.count_timer = setTimeout(() => {
      _this.countOffers();
    }, 500);
  }
  @Watch("profession_user", { deep: true })
  onChangeModality() {
    if ((this as any).profession_user) {
      if (
        (this as any).profession_user.is_part_time ||
        (this as any).profession_user.is_full_time ||
        (this as any).profession_user.is_remote ||
        (this as any).profession_user.is_temporal
      )
        this.modality = false;
    }
  }

  async countOffers() {
    if (!(this as any).is_counting) {
      (this as any).is_counting = true;
      const response = await (this as any).$root._get("offer/count", {
        is_part_time: (this as any).profession_user.is_part_time ? 1 : 0,
        is_full_time: (this as any).profession_user.is_full_time ? 1 : 0,
        is_remote: (this as any).profession_user.is_remote ? 1 : 0,
        is_temporal: (this as any).profession_user.is_temporal ? 1 : 0,
        lowest_expected_salary: (this as any).profession_user
          .lowest_expected_salary,
        highest_expected_salary: (this as any).profession_user
          .highest_expected_salary,
        areaId: (this as any).profession_user.area
          ? (this as any).profession_user.area.value
          : "",
      });
      (this as any).searchProffesional = response.totalRows;
      (this as any).is_counting = false;
    }
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }

  customFormatter(date: any) {
    return moment(date).format("DD-MM-YYYY");
  }

  onPasswordChange(value: any, type: any) {
    if (type === 1) {
      (this as any).form.pass = value.target.value;
    } else (this as any).form.rpass = value.target.value;
  }

  async createAccount() {
    if ((this as any).busy_api) return false;

    let elements = [
      "type_document",
      "number_document",
      "name",
      "ape",
      "email",
	    "email2",
      "study_level",
      "emp",
      "pass",
      "phonepais",
      "rpass",
      "checked1",
    ];

    let phone1 = null,
      phone = null;
    if (
      (this as any).form.phone !== "" ||
      (this as any).form.phonepais !== "" ||
      (this as any).form.phonearea !== ""
    ) {
      phone1 = `${(this as any).$root.getPhoneCountryCode(
        (this as any).form.phonepais
      )}${(this as any).$root.getPhoneAreaCode(
        (this as any).form.phonearea
      )}${(this as any).$root.getPhoneNumber((this as any).form.phone)}`;
      phone = (this as any).$root.parsePhone(phone1);
    }

	//valida el doble ingreso del email
	if ((this as any).form.email !==(this as any).form.email2)
	{
		this.EmailEquals = false;
		return false;
	}
	else
	{
		this.EmailEquals = true;
	}

    await (this.$root as any).validateBeforeSubmit(
      elements,
      (this as any).form
    );

    this.errorPhone = (this as any).$root.validateNumber(phone1);

    if (
      (this.$root as any).error_bt.length === 0 &&
      (this as any).form.checked1 &&
      (this as any).form.pass === (this as any).form.rpass &&
      (this as any).errorPhone.flag
    ) {
      // let phone: any = (this as any).$root.parsePhone((this as any).form.cel);
      (this as any).busy_api = true;

      let response: any = false;
      try {
        response = await (this.$root as any)._post("user", {
          dni_type: (this as any).form.type_document.id,
          dni: (this as any).form.number_document,
          first_name: (this as any).form.name,
          last_name: (this as any).form.ape,
          username: (this as any).form.email,
          email: (this as any).form.email,
          phone: phone1,
          password: (this as any).form.pass,
          nucleus_user: {
            c_nro_doc: (this as any).form.number_document,
            oi_tipo_documento:
              ((this as any).form.type_document &&
                (this as any).form.type_document.external_id) ||
              0,
            d_apellido: (this as any).form.ape,
            d_email: (this as any).form.email,
            te_celular: phone ? phone.nu_nro : "",
            c_area_cel: phone ? phone.nu_area : "",
            c_pais_cel: phone ? phone.nu_pais : "",
            d_nombres: (this as any).form.name,
            estudiosCV: [
              {
                d_otro_est_educ: "",
                oi_nivel_estudio: (this as any).form.study_level.external_id,
                oi_estado_est: "",
                oi_estudio: "",
              },
            ],
          },
          role: 2,
        });
      } catch (e) {
        if (e.message.indexOf("Email already in use") >= 0) {
          this.emailDuplicate = true;
        }
        if (e.message.indexOf("Dni already in use") >= 0) {
          let email = e.message.split("|")[1];
          this.dniDuplicate = true;
          return Swal.fire(
            (this as any).$root.config.CreateSteps.CreateAccount.errorMessages
              .duplicateDniTitle,
            (this as any).$root.config.CreateSteps.CreateAccount.errorMessages.duplicateDniMessage.replace(
              "{{email}}",
              email[0] + "****" + email.substring(email.indexOf("@") - 3)
            ),
            "error"
          );
        }
      }

      if (response && response.user) {
        const response2 = await (this.$root as any)._post("usereducation", {
          study_level:
            typeof (this as any).form.study_level === "object"
              ? (this as any).form.study_level.id
              : (this as any).form.study_level,
          userId: response.user.id,
        });

        const response3 = await (this as any).$root._post("user/login", {
          username: (this as any).form.email,
          password: (this as any).form.pass,
        });
        (this as any).$store.commit("setToken", response3.token);

        const response4: any = await (this.$root as any)._post(
          "userprofessional",
          {
            profession: null,
            desired_place_lat: null,
            desired_place_lng: null,
            lowest_expected_salary: null,
            highest_expected_salary: null,
            wants_job_offers: false,
            is_part_time: (this as any).form.emp.external_id === 2,
            is_full_time: (this as any).form.emp.external_id === 1,
            is_remote: (this as any).form.emp.external_id === 103,
            is_temporal: (this as any).form.emp.external_id === 102,
            areaId: null,
            locationId: null,
          }
        );

        this.profession_user = response4;

        const response5 = await (this.$root as any)._put(
          "user/" + response.user.id,
          {
            usersProfessionalId: response4.id,
          }
        );

        await (this as any).$root.reloadUser();
        dataLayer.push({
          event: "VirtualPageview",
          virtualPageURL: "/crear-cuenta/estado-pendiente",
          virtualPageTitle: "Crear Cuenta - Pendiente",
        });

        (this as any).nextStep(3);
        window.scrollTo(0, 0);
      }

      (this as any).busy_api = false;
    } else {
      if (!(this as any).errorPhone.flag) {
        this.numberInvalid = true;
      } else {
        this.numberInvalid = false;
      }
    }
  }

  async createAccountWithSN() {
    let elements = ["type_document", "number_document", "study_level", "emp"];
    await (this.$root as any).validateBeforeSubmit(
      elements,
      (this as any).form
    );
    if (
      (this.$root as any).error_bt.length === 0 &&
      (this as any).form.checked1
    ) {
      let nu = this.$store.state.user.nucleus_user;
      nu.c_nro_doc = (this as any).form.number_document;
      nu.oi_tipo_documento =
        ((this as any).form.type_document &&
          (this as any).form.type_document.external_id) ||
        0;
      nu.estudiosCV = [
        {
          d_otro_est_educ: "",
          oi_nivel_estudio: (this as any).form.study_level.external_id,
          oi_estado_est: "",
          oi_estudio: "",
        },
      ];

      try {
        const response = await (this.$root as any)._put(
          "user/" + (this as any).$store.state.user.id,
          {
            dni_type: (this as any).form.type_document.id,
            dni: (this as any).form.number_document,
            nucleus_user: nu,
          }
        );

        const response2 = await (this.$root as any)._post("usereducation", {
          study_level:
            typeof (this as any).form.study_level === "object"
              ? (this as any).form.study_level.id
              : (this as any).form.study_level,
          userId: response.user.id,
        });

        const response4: any = await (this.$root as any)._post(
          "userprofessional",
          {
            profession: null,
            desired_place_lat: null,
            desired_place_lng: null,
            lowest_expected_salary: null,
            highest_expected_salary: null,
            wants_job_offers: false,
            is_part_time: (this as any).form.emp.external_id === 2,
            is_full_time: (this as any).form.emp.external_id === 1,
            is_remote: (this as any).form.emp.external_id === 103,
            is_temporal: (this as any).form.emp.external_id === 102,
            areaId: null,
            locationId: null,
          }
        );

        this.profession_user = response4;

        const response5 = await (this.$root as any)._put(
          "user/" + response.user.id,
          {
            dni_type: (this as any).form.type_document.id,
            dni: (this as any).form.number_document,
            usersProfessionalId: response4.id,
          }
        );

        await (this as any).$root.reloadUser();

        dataLayer.push({
          event: "VirtualPageview",
          virtualPageURL: "/crear-cuenta/estado-pendiente",
          virtualPageTitle: "Crear Cuenta - Pendiente",
        });

        this.nextStep(3);
        window.scrollTo(0, 0);
      } catch (e) {
        if (e.message.indexOf("Email already in use") >= 0) {
          this.emailDuplicate = true;
        }
        if (e.message.indexOf("Dni already in use") >= 0) {
          let email = e.message.split("|")[1];
          this.dniDuplicate = true;
          return Swal.fire(
            (this as any).$root.config.CreateSteps.CreateAccount.errorMessages
              .duplicateDniTitle,
            (this as any).$root.config.CreateSteps.CreateAccount.errorMessages.duplicateDniMessage.replace(
              "{{email}}",
              email[0] + "****" + email.substring(email.indexOf("@") - 3)
            ),
            "error"
          );
        }
      }
    }
  }

  async infoAdditional() {
    let elements = ["age", "nationality", "address", "location"];
    await (this.$root as any).validateBeforeSubmit(
      elements,
      (this as any).form
    );

    if (
      (this as any).$root.error_bt.indexOf("birthday") < 0 &&
      (this as any).$root.isUnder18((this as any).form.age)
    ) {
      (this as any).$root.error_bt.push("birthday");
    }

    if ((this.$root as any).error_bt.length === 0) {
      let nu = this.$store.state.user.nucleus_user;
      // nu.c_nro_doc = (this as any).form.number_document;
      // nu.c_pais =
      //   ((this as any).form.address &&
      //     (this as any).form.address.external_id) ||
      //   0;
      nu.f_nacim = (this as any).form.age;
      // nu.oi_tipo_documento =
      //   ((this as any).form.type_document &&
      //     (this as any).form.type_document.external_id) ||
      //   0;
      nu.oi_nacionalidad =
        ((this as any).form.nationality &&
          (this as any).form.nationality.external_id) ||
        0;
      nu.c_nro = (this as any).form.number_address || "";
      nu.c_piso = (this as any).form.floor_address || "";
      nu.c_departamento = (this as any).form.dept_address || "";
      nu.d_calle = (this as any).form.address || "";
      nu.oi_localidad =
        ((this as any).form.location &&
          (this as any).form.location.external_id) ||
        0;
      nu.oi_provincia =
        ((this as any).form.location && (this as any).form.location.prov_id) ||
        0;
      nu.oi_pais =
        ((this as any).form.location && (this as any).form.location.pais_id) ||
        0;
      let new_education = {
        oi_estudio:
          typeof (this as any).form.study === "object"
            ? (this as any).form.study.external_id
            : "",
        oi_nivel_estudio:
          typeof (this as any).form.study_level === "object"
            ? (this as any).form.study_level.external_id
            : "",
        oi_estado_est:
          typeof (this as any).form.study_status === "object"
            ? (this as any).form.study_status.external_id
            : "",
        d_otro_est_educ: (this as any).form.university,
      };
      if (!nu.estudiosCV) {
        nu.estudiosCV = [{ new_education }];
      } else if (nu.estudiosCV.length) nu.estudiosCV[0] = new_education;
      else nu.estudiosCV.push({ new_education });

      const response = await (this.$root as any)._put(
        "user/" + (this as any).$store.state.user.id,
        {
          // dni_type: (this as any).form.type_document.id,
          // dni: (this as any).form.number_document,
          age: moment().diff((this as any).form.age, "years"),
          birthday: (this as any).form.age,
          role: 2,
          address: (this as any).form.address,
          nucleus_user: nu,
        }
      );

      await (this as any).$root.reloadUser();

      if (
        this.$store.state.user.users_educations &&
        this.$store.state.user.users_educations.length
      ) {
        await (this.$root as any)._put(
          "usereducation/" + this.$store.state.user.users_educations[0].id,
          {
            study: (this as any).form.study.id,
            study_level: (this as any).form.study_level.id,
            study_status: (this as any).form.study_status.id,
            university: (this as any).form.university,
          }
        );
      } else {
        await (this.$root as any)._post("usereducation/", {
          study: (this as any).form.study.id,
          study_level: (this as any).form.study_level.id,
          study_status: (this as any).form.study_status.id,
          university: (this as any).form.university,
          userId: this.$store.state.user.id,
        });
      }

      this.nextStep(6);
    }
  }

  async addExperience() {
    let elements = ["title", "nucleusTypeId", "company", "from"];
    if (!(this as any).form.current_job && (this as any).form.to) {
      elements.push("to");
    }
    await (this.$root as any).validateBeforeSubmit(
      elements,
      (this as any).form
    );
    if ((this.$root as any).error_bt.length === 0) {
      this.reinitExp = false;
      const response: any = await (this.$root as any)._post("userexperience", {
        title: (this as any).form.title,
        description: (this as any).form.description,
        current_job: (this as any).form.current_job,
        company: (this as any).form.company,
        from: (this as any).form.from,
        to: (this as any).form.to,
        nucleusTypeId: (this as any).form.nucleusTypeId.id,
        userId: (this as any).$store.state.user.id,
      });
      if (response) {
        (this.exp_user as any).push(response);
        this.curriculum = true;
        this.curriculum_add = false;
      }

      let nu = this.$store.state.user.nucleus_user;

      if (nu.expLaboralCV && nu.expLaboralCV.length) {
        nu.expLaboralCV.push({
          d_empresa: (this as any).form.company,
          d_puesto: (this as any).form.title,
          f_egreso: (this as any).form.current_job
            ? null
            : (this as any).form.to,
          f_ingreso: (this as any).form.from,
          o_tareas: (this as any).form.description,
          oi_area_lab:
            ((this as any).form.nucleusTypeId &&
              (this as any).form.nucleusTypeId.external_id) ||
            null,
        });
      } else {
        nu.expLaboralCV = [
          {
            d_empresa: (this as any).form.company,
            d_puesto: (this as any).form.title,
            f_egreso: (this as any).form.current_job
              ? null
              : (this as any).form.to,
            f_ingreso: (this as any).form.from,
            o_tareas: (this as any).form.description,
            oi_area_lab:
              ((this as any).form.nucleusTypeId &&
                (this as any).form.nucleusTypeId.external_id) ||
              null,
          },
        ];
      }

      await (this.$root as any)._put(
        "user/" + (this as any).$store.state.user.id,
        {
          nucleus_user: nu,
        }
      );
      await (this as any).$root.reloadUser();
      if (this.curriculum) {
        this.exp_user = this.$store.state.user.users_experiences;
        setTimeout(() => {
          this.reinitExp = true;
        }, 100);
      }
    }
  }

  async deleteExperience(index: any) {
    const response3 = await (this.$root as any)._delete(
      "userexperience/" + (this.exp_user[index] as any).id,
      {}
    );
    this.$delete(this.exp_user, index);
    let nu = this.$store.state.user.nucleus_user;
    if (nu.expLaboralCV && nu.expLaboralCV.length) {
      nu.expLaboralCV.splice(index, 1);
      await (this.$root as any)._put(
        "user/" + (this as any).$store.state.user.id,
        {
          nucleus_user: nu,
        }
      );

      await (this as any).$root.reloadUser();
      if (!(this as any).$store.state.user.users_experiences.length) {
        this.curriculum = false;
      }
    }
  }

  async addProfessionalInfo() {
    let elements = ["profession", "desired_place_lat", "area"];
    await (this.$root as any).validateBeforeSubmit(
      elements,
      this.profession_user
    );
    if (
      !(this as any).profession_user.is_part_time &&
      !(this as any).profession_user.is_full_time &&
      !(this as any).profession_user.is_remote &&
      !(this as any).profession_user.is_temporal
    ) {
      this.modality = true;
    }
    if (
      (this.$root as any).error_bt.length === 0 &&
      !this.modality &&
      (this as any).profession_user.desired_place_lat.id
    ) {
      const response: any = await (this.$root as any)._put(
        `userprofessional/${
          (this as any).$store.state.user.users_professional.id
        }`,
        {
          profession: (this as any).profession_user.profession,
          desired_place_lat: null,
          desired_place_lng: null,
          lowest_expected_salary: (this as any).profession_user
            .lowest_expected_salary,
          highest_expected_salary: (this as any).profession_user
            .highest_expected_salary,
          wants_job_offers: (this as any).profession_user.wants_job_offers,
          is_part_time: (this as any).profession_user.is_part_time,
          is_full_time: (this as any).profession_user.is_full_time,
          is_remote: (this as any).profession_user.is_remote,
          is_temporal: (this as any).profession_user.is_temporal,
          areaId: (this as any).profession_user.area.id,
          locationId: (this as any).profession_user.desired_place_lat.id,
        }
      );
      const response2 = await (this.$root as any)._put(
        "user/" + (this as any).$store.state.user.id,
        {
          usersProfessionalId: response.id
        }
      );

      this.modality = false;
      this.nextStep(8);
      await (this as any).$root.reloadUser();
    }
  }

  nextStep(step: any) {
    this.current_step = step;
    window.scrollTo(0, 0);
  }

  prevStep() {
    this.current_step = this.current_step - 1;
    window.scrollTo(0, 0);
  }

  loadTypes() {
    let types: any = [
      { key: "NIVELES_EST", model: "optionsEst" },
      { key: "TIPOS_PUESTO", model: "optionsEmp" },
      { key: "TIPOS_DOC", model: "typeDoc" },
      { key: "NACIONALIDADES", model: "nacionalidad" },
      { key: "PAISES", model: "countries" },
      { key: "ESTUDIOS", model: "educationCareer" },
      { key: "ESTADOS_EST", model: "educationStatus" },
    ];
    types.forEach((t: any) => {
      (this as any).$root._get(`nucleus_types/${t.key}`).then((data: any) => {
        (this as any)[t.model] = data.data.map((item: any) => {
          return { ...item, label: item.description };
        });
      });
    });
  }

  async mounted() {
    this.current_step = this.activeStep || 1;
    this.loadTypes();
    if (this.$store.state.user.id) {
      if (!this.$store.state.user.active) {
        (this as any).nextStep(3);
      } else if (
        this.$store.state.user.usersProfessionalId &&
        this.$store.state.user.users_professional.profession
      ) {
        (window as any).location = "/perfil";
      } else if (this.$store.state.user.users_experiences.length) {
        (this as any).nextStep(7);
        window.scrollTo(0, 0);
        (this as any).countOffers();
      } else if (this.$store.state.user.address) {
        (this as any).nextStep(6);
        window.scrollTo(0, 0);
      } else if (this.$store.state.user.users_educations.length) {
        (this as any).nextStep(3);
        window.scrollTo(0, 0);
      } else if (this.$store.state.user.last_name) {
        (this as any).nextStep(2);
        window.scrollTo(0, 0);
      }
    }
    if (
      (this as any).$store.state.user &&
      (this as any).$store.state.user.users_experiences
    ) {
      (this as any).exp_user = (this as any).$store.state.user.users_experiences;
    }
    if ((this as any).exp_user && (this as any).exp_user.length) {
      (this as any).curriculum = true;
    }

    if ((this as any).$store.state.user.dni_type) {
      (this as any).form.type_document = (this as any).typeDoc.find(
        (i: any) => i.id === (this as any).$store.state.user.dni_type
      );
      (this as any).form.number_document = (this as any).$store.state.user.dni;
    }

    if (
      (this as any).$store.state.user.users_educations &&
      (this as any).$store.state.user.users_educations.length
    ) {
      (this as any).form.study_level = (this as any).optionsEst.find(
        (est: any) => {
          console.log(
            est.id,
            (this as any).$store.state.user.users_educations[0].id
          );
          return (
            est.id ===
            (this as any).$store.state.user.users_educations[0].study_level
          );
        }
      );
    }

    if ((this as any).$store.state.user.usersProfessionalId) {
      (this as any).profession_user = {
        ...(this as any).profession_user,
        is_part_time: (this as any).$store.state.user.users_professional
          .is_part_time,
        is_full_time: (this as any).$store.state.user.users_professional
          .is_full_time,
        is_remote: (this as any).$store.state.user.users_professional.is_remote,
        is_temporal: (this as any).$store.state.user.users_professional
          .is_temporal
      };
    }
    (this as any).visibile = true;
  }

  addSizeCv(size: any, typecv: any) {
    (this as any).sizeCv = parseInt(String(size / 1000));
    (this as any).typeCv = typecv;
  }
  newExp(user: any) {
    (this as any).reinitExp = false;
    console.log(this.reinitExp);
    this.exp_user = user.users_experiences;
    setTimeout(() => {
      this.reinitExp = true;
    }, 100);
  }
  popEmail() {
    this.emailDuplicate = false;
    this.dniDuplicate = false;
    let i = (this as any).$root.error_bt.indexOf("email");
    if (i >= 0) {
      (this as any).$root.error_bt.splice(i, 1);
    }
  }
  popPhone() {
    let i = (this as any).$root.error_bt.indexOf("phonepais");
    if (i >= 0) {
      (this as any).$root.error_bt.splice(i, 1);
    }
  }

  async fetchOptions(search: any, loading: any) {
    if (search.length > 2) {
      loading(true);
      const response = await (this as any).$root._get(
        `misc/locations?q=${search}`,
        {}
      );
      (this as any).optionsPlaces = response;
      loading(false);
      if (response.length === 0) {
        (this as any).msjSlot = "Lo sentimos, no hay resultados.";
      }
    } else {
      this.msjSlot = "Escribe una ubicacion";
    }
  }

  reset_form() {
    this.form.nucleusTypeId = "";
    this.form.company = "";
    this.form.description = "";
    this.form.title = "";
    this.form.to = "";
    this.form.from = "";
  }

  handleSelect(event: any) {
    if (!event) {
      (this as any).form.nationality = null;
    }
  }
}
